import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrophone = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 5.2,
			y: 1,
			width: 3.6,
			height: 8,
			rx: 1.8
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.5 6.4C3.83137 6.4 4.1 6.66863 4.1 7V7.6C4.1 9.20163 5.39837 10.5 7 10.5C8.60163 10.5 9.9 9.20163 9.9 7.6V7C9.9 6.66863 10.1686 6.4 10.5 6.4C10.8314 6.4 11.1 6.66863 11.1 7V7.6C11.1 9.68706 9.5347 11.4085 7.6 11.6631V12.8H8.8C9.13137 12.8 9.4 13.0686 9.4 13.4C9.4 13.7314 9.13137 14 8.8 14H5.2C4.86863 14 4.6 13.7314 4.6 13.4C4.6 13.0686 4.86863 12.8 5.2 12.8H6.4V11.6631C4.4653 11.4085 2.9 9.68706 2.9 7.6V7C2.9 6.66863 3.16863 6.4 3.5 6.4Z"
		})
	]
});
const ForwardRef = forwardRef(SvgMicrophone);
export { ForwardRef as ReactComponent };
